// @ts-nocheck
let storage;

const initilised = new Promise(function(resolve) {
    localforage.getItem('trpPreferences', function(err, value) {
        if (err) {
            console.log(`error retrieving preferences:${err}`);
        } else {
            storage = value || {};
        }
        resolve();
    });
});

function localForageSet(cb) {
    localforage.setItem('trpPreferences', storage, function(err) {
        if (err) {
            console.log(`error setting preferences:${err}`);
        }
        cb();
    });
}

export function get(cb) {
    initilised.then(() => cb(storage));
}

export function set(cb, prefs) {
    initilised.then(() => {
        Object.assign(storage, prefs);
        localForageSet(cb);
    });
}

export function remove(cb, key) {
    initilised.then(() => {
        delete storage[key];
        localForageSet(cb);
    });
}

export function getItem(key, callback) {
    return localforage.getItem(key, callback);
}

export function setItem(key, value, callback) {
    return localforage.setItem(key, value, callback);
}

export function removeItem(key, callback) {
    return localforage.removeItem(key, callback);
}
